import React, { useState, useEffect, useRef } from 'react';
import { TextScramble } from '@skyshots/react-text-scrambler';

const BaffleText = ({
  text,
  revealDuration = 3000,
  revealDelay = 500,
  manualStart = false, // NEW: trigger from outside
  callMethodTime,
  parentMethod,
}) => {
  const ref = useRef(null);
  const [startScramble, setStartScramble] = useState(false);
  const [forceReveal, setForceReveal] = useState(false);

  useEffect(() => {
    if (manualStart) {
      setStartScramble(true);
      setTimeout(() => setForceReveal(true), revealDuration + revealDelay);
      if (callMethodTime && typeof parentMethod === 'function') {
        setTimeout(() => parentMethod(), callMethodTime);
      }
      return; // skip observer if manualStart triggered
    }

    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartScramble(true);
          setTimeout(() => setForceReveal(true), revealDuration + revealDelay);
          if (callMethodTime && typeof parentMethod === 'function') {
            setTimeout(() => parentMethod(), callMethodTime);
          }
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [manualStart, callMethodTime, parentMethod, revealDuration, revealDelay]);

  return (
    <span ref={ref} className='baffle_text'>
      {!forceReveal ? (
        <TextScramble
          texts={[text]}
          letterSpeed={100}
          nextLetterSpeed={revealDuration}
          pauseTime={revealDelay}
          paused={!startScramble}
        />
      ) : (
        <span>{text}</span>
      )}
    </span>
  );
};

export default BaffleText;
